import React, { useEffect, useState } from 'react';
import './CommunityLiveShopping.scss';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { http, FxDateDisplay, FxDateTimeDisplay, FxSelect, localstorage } from '../../fx-core';
import { NoRecords } from '../../NoRecords/NoRecords';

const CommunityLiveShopping = (props) => {

    let defaultFilter: any = {
        communityId: props.communityId
    };

    const [liveShopping, setLiveShopping] = useState([]);
    const [filters, setFilters] = useState(defaultFilter);
    const [communityList, setCommunityList] = useState([]);

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        let filterObj = {
            communityId: filters.communityId
        }
        if (item.name == 'communityId') {
            filterObj.communityId = item.value;
        }
        getCommunityLiveShopping(filterObj);
    };

    const handleFilterChange = (data) => {
        setFilters(prevState => {
            return { ...prevState, ...data }
        });
    };

    const getMyRegionCommunities = () => {
        let inputData = {
            lookups: {
                MyRegionCommunities: { default: false }
            },
            filters: {
                userId: localstorage.getItem("userId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            getMyRegionCommunitiesCallBack(response);
        })
    };

    const getMyRegionCommunitiesCallBack = (res) => {
        let result = res.data;
        setCommunityList(result.MyRegionCommunities);
    };

    const getMyZoneCommunities = () => {
        let inputData = {
            lookups: {
                MyZoneCommunities: { default: false }
            },
            filters: {
                userId: localstorage.getItem("userId")
            }
        };
        let apiOptions = {
            url: 'options/lookup',
            data: inputData
        };
        http.post(apiOptions).then(response => {
            getMyZoneCommunitiesCallBack(response);
        })
    }

    const getMyZoneCommunitiesCallBack = (res) => {
        let result = res.data;
        setCommunityList(result.MyZoneCommunities);
    };

    const getMyAdminCommunities = () => {
        let apiOptions: any = {
            url: 'community/role/list',
            data: {}
        };
        http.post(apiOptions).then(res => { getMyAdminCommunitiesCallBack(res) });
    };

    const getMyAdminCommunitiesCallBack = (res) => {
        let result = res.data;
        let commuArr: any = [];
        for (let item of result) {
            let itemObj: any = {
                id: item.id,
                text: item.name
            };
            commuArr.push(itemObj);
        }
        setCommunityList(commuArr);
    };

    const initCalls = () => {
        if (props.parent == 'REGIONALMANAGER') {
            getMyRegionCommunities();
        }
        else if (props.parent == 'ZONALMANAGER') {
            getMyZoneCommunities();
        }
        else if (props.parent == 'COMMADMIN') {
            getMyAdminCommunities();
        }
    }

    const getCommunityLiveShopping = (data) => {
        let inputData = {
            ds: {
                resultset: [
                    { key: "liveShopping", type: "list" }
                ]
            },
            data: {
                communityId: data.communityId
            }
        };
        let apiOptions: any = {
            url: `general/dbo/GetCommunityLiveShoppings`,
            data: inputData
        };
        http.post(apiOptions).then(res => {
            getCommunityLiveShoppingCallBack(res);
        });
    };

    const getCommunityLiveShoppingCallBack = (res) => {
        let result = res.data;
        setLiveShopping(result.liveShopping);
    }

    useEffect(() => {
        initCalls();
        getCommunityLiveShopping(filters);
    }, []);

    return (
        <div className='communityliveshopping-ui'>
            <div className='content-container'>
                <div className="content">
                    <div className='row my-4 mx-2'>
                        <div className='col-3'>
                            <FxSelect name="communityId" variant="outlined"
                                label="Community"
                                options={communityList}
                                selectedValue={filters.communityId}
                                valueField="id"
                                displayField="text"
                                size="small"
                                style={{ width: 260 }}
                                onValueChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='row my-4 mx-4 pt-2'>
                        <TableContainer component={Paper}>
                            <Table className="table-striped" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Stall Name</TableCell>
                                        <TableCell>Community</TableCell>
                                        <TableCell>Live Stream Date</TableCell>
                                        <TableCell align='right'>Duration (mins)</TableCell>
                                        <TableCell>Time</TableCell>
                                        <TableCell>Payment</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        liveShopping.length == 0 &&
                                        <TableCell colSpan={7}>
                                            <NoRecords />
                                        </TableCell>
                                    }
                                    {
                                        liveShopping.length > 0 && liveShopping.map((row: any, i) => (
                                            <TableRow key={i}>
                                                <TableCell>
                                                    {row.liveStreamName}
                                                </TableCell>
                                                <TableCell>
                                                    {row.stallName}
                                                </TableCell>
                                                <TableCell>
                                                    {row.communityName}
                                                </TableCell>                                                
                                                <TableCell>
                                                    <FxDateDisplay value={row.liveStreamDate} />
                                                </TableCell>
                                                <TableCell align='right'>
                                                    {
                                                        row.duration > 0 &&
                                                        <span>{row.duration}</span>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    <i className="far fa-clock color-aaa px-1"></i>
                                                    <FxDateTimeDisplay value={row.startTime} displayType="time" />
                                                    <span className='px-1'>-</span>
                                                    <span>
                                                        <FxDateTimeDisplay value={row.endTime} displayType="time" />
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        row.isPaid &&
                                                        <span>Paid</span>
                                                    }
                                                    {
                                                        !row.isPaid &&
                                                        <span>Pending</span>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CommunityLiveShopping;